import { render, staticRenderFns } from "./QrcodeReader.vue?vue&type=template&id=8580fa5c&scoped=true&"
import script from "./QrcodeReader.vue?vue&type=script&lang=js&"
export * from "./QrcodeReader.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeReader.vue?vue&type=style&index=0&id=8580fa5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8580fa5c",
  null
  
)

export default component.exports